/* eslint-disable no-console */
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import history from '~/services/history';
import api from '~/services/api';
import * as actions from './actions';
import * as actionsAuth from '../auth/actions';
import * as types from './types';

export function* sendGeneralIndicators({ payload }) {
  // Clear errors
  yield put(
    actions.generalIndicatorsFailure({
      errorData: null,
    })
  );

  try {
    const { data } = payload;

    const response = yield call(api.post, 'indicadores-gerais', data);

    if (response.status === 201) {
      toast.success('Envio realizado com sucesso!');

      yield put(
        actions.generalIndicatorsSuccess({
          generalIndicatorData: response.data,
        })
      );

      const { auth } = yield select();

      yield put(
        actionsAuth.signInSuccess({
          ...auth,
          systemConfig: {
            ...auth.systemConfig,
            competenciaJaEnviada: true,
          },
        })
      );

      setTimeout(() => {
        history.push('/');
      }, 800);
    }
  } catch (error) {
    yield put(
      actions.generalIndicatorsFailure({
        errorData: error?.response?.data,
      })
    );
    if (error) {
      Swal.fire({
        title: 'Envio recusado!',
        text:
          'Confira as inconsistências do arquivo antes de alterar o arquivo existente.',
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
    }
  }
}

/**
 * GET COMPETENCES
 */

export function* getGeneralCompetences() {
  const { institutionId } = yield select(state => state.auth);

  try {
    const response = yield call(
      api.get,
      `indicadores-gerais/instituicoes/${institutionId}/competencias`
    );

    // filtra por competencias abertas
    const competencias = response?.data?.filter(item => item.status === 'O');

    yield put(
      actions.generalCompetencesSuccess({
        generalIndicatorCompetences: competencias,
      })
    );
  } catch (error) {
    console.log(error);
    yield put(actions.generalCompetencesFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.GENERAL_INDICATORS_REQUEST, sendGeneralIndicators),
  takeLatest(types.GENERAL_COMPETENCES_REQUEST, getGeneralCompetences),
]);
